// src/api/search.js
import axios from 'axios'

// 基础配置（根据实际接口调整）
const baseURL = process.env.VUE_APP_API_BASE_URL || '/api'

// 各平台搜索接口映射
export const searchApi = {
  // 淘宝
  taobao: (keyword) => {
    return axios.get(`${baseURL}/product/taobao/search`, {
      params: { keyword, page: 1, size: 20 }
    })
  },
  // 京东
  jd: (keyword) => {
    return axios.get(`${baseURL}/product/search`, {
      params: { keyword, page: 1, size: 20 }
    })
  },
  // 拼多多
  pdd: (keyword) => {
    return axios.get(`${baseURL}/product/pdd/search`, {
      params: { keyword, page: 1, size: 20 }
    })
  },
  // 其他平台...
}

// 通用搜索方法（根据平台调用对应接口）
export const fetchSearchResult = async (platform, keyword) => {
  if (!searchApi[platform]) {
    throw new Error(`未配置${platform}平台的搜索接口`)
  }
  try {
    const res = await searchApi[platform](keyword)
    return res.data // 假设接口返回 { code: 200, data: [...] }
  } catch (error) {
    console.error(`【${platform}搜索失败】`, error)
    throw error // 抛出错误，让页面处理
  }
}

// 获取搜索联想词
export const getSearchSuggestions = (params) => {
  return axios.get(`${baseURL}/search/suggest`, {
    params
  })
}
